import { styled } from '@mui/joy';

import { externalQuoteTheme } from 'external-quote/styles';

export const TabsContainer = styled('div')({
  backgroundColor: '#FFFFFF',
  borderBottom: '1px solid #E0E0E0',
  display: 'flex',
  alignItems: 'flex-end',
  paddingLeft: '12px',
  overflowX: 'auto',
  scrollbarWidth: 'thin',

  '&::-webkit-scrollbar': {
    height: '4px',
  },

  '&::-webkit-scrollbar-track': {
    backgroundColor: '#F0F0F0',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C0C0C0',
    borderRadius: '2px',
  },
});

export const Tab = styled('button')<{ active?: boolean }>(({ active }) => ({
  padding: '10px 16px',
  border: 'none',
  backgroundColor: 'transparent',
  fontSize: '15px',
  color: active ? externalQuoteTheme.colors.primaryBlue : externalQuoteTheme.colors.textSecondary,
  cursor: 'pointer',
  position: 'relative',
  whiteSpace: 'nowrap',
  transition: 'color 0.2s',
  borderBottom: active ? '3px solid #0066CC' : '3px solid transparent',
  marginBottom: '-2px',

  '&:hover': {
    color: active ? '#0066CC' : '#333333',
  },
}));
